import React, { Fragment } from 'react';
import { HomeIcon, ChevronRightIcon } from 'lucide-react';
interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface PageHeroBreadcrumbProps {
  breadcrumbs: BreadcrumbItem[];
  title: string;
  description?: string;
  showTitle?: boolean;
  showDescription?: boolean;
}
export function PageHeroBreadcrumb({
  breadcrumbs,
  title,
  description,
  showTitle = true,
  showDescription = true
}: PageHeroBreadcrumbProps) {
  return <div className="bg-white border-b border-gray-100" data-id="element-3127" data-mp="kw504j5iy5vb">
      <div className="container mx-auto px-4 pt-20 pb-6 md:pt-8 md:pb-8" data-id="element-3128" data-mp="pu6guxfh9t3m">
        {/* Breadcrumb Navigation with Horizontal Scroll */}
        <div className="overflow-x-auto scrollbar-hide -mx-4 px-4 mb-3" data-id="element-3129" data-mp="uuaywrw1avvy">
          <nav className="flex items-center text-[13px] text-gray-500 whitespace-nowrap min-w-max" aria-label="Breadcrumb" data-id="element-3130" data-mp="zs2ohf97i5wz">
            {breadcrumbs.map((item, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return <Fragment key={index} data-id="element-3131" data-mp="7rt31yhzbo75" data-mpi={index}>
                  {index > 0 && <ChevronRightIcon className="w-3.5 h-3.5 mx-2 text-gray-400 flex-shrink-0" aria-hidden="true" data-id="element-3132" data-mp="2trjlcgn5mv5" />}
                  {item.href && !isLast ? <a href={item.href} className="hover:text-[#1E2B55] transition-colors flex items-center flex-shrink-0" data-id="element-3133" data-mp="3pyfu9qga95h9">
                      {index === 0 && <HomeIcon className="w-3.5 h-3.5 mr-1.5 flex-shrink-0" data-id="element-3134" data-mp="3b9t4eut14vbs" />}
                      <span data-id="element-3135" data-mp="378hmlbgedee5">{item.label}</span>
                    </a> : <span className={`flex items-center flex-shrink-0 ${isLast ? 'text-[#0f172a] font-medium' : ''}`} aria-current={isLast ? 'page' : undefined} data-id="element-3136" data-mp="3294vufmenn6a">
                      {index === 0 && <HomeIcon className="w-3.5 h-3.5 mr-1.5 flex-shrink-0" data-id="element-3137" data-mp="2noiph6olrj8u" />}
                      <span data-id="element-3138" data-mp="2sjfwy968hkjm">{item.label}</span>
                    </span>}
                </Fragment>;
          })}
          </nav>
        </div>
        {/* Page Title - Conditionally rendered */}
        {showTitle && <h1 className="text-2xl md:text-[32px] font-bold text-[#0f172a] mb-2 tracking-tight" data-id="element-3139" data-mp="36cnqw7hses4h">
            {title}
          </h1>}
        {/* Description - Conditionally rendered */}
        {showDescription && description && <p className="text-sm md:text-base text-gray-600 leading-relaxed max-w-4xl" data-id="element-3140" data-mp="2wmufb6hnad08">
            {description}
          </p>}
      </div>
    </div>;
}